import { Injectable } from '@angular/core';
import { Auth, OAuthProvider } from '@angular/fire/auth';
import { SignInWithApple, SignInWithAppleOptions, SignInWithAppleResponse } from '@capacitor-community/apple-sign-in';
import { GoogleAuthProvider } from 'firebase/auth';
import { Device } from '@capacitor/device';
import { OAuth2Client } from '@byteowls/capacitor-oauth2';
import { jwtDecode } from 'jwt-decode';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Preferences } from '@capacitor/preferences';
@Injectable({
  providedIn: 'root'
})
export class SocialLoginService {
  constructor(private auth: Auth, private afAuth: AngularFireAuth ) {}


  async LoginWithAppleNative() {
    try {
      let options: SignInWithAppleOptions = {
        clientId: 'com.touchconnectapp.dev',
        redirectURI: 'https://touchconnectapp.firebaseapp.com/__/auth/handler',
        scopes: 'email',
        state: '12345',
        nonce: 'nonce',
      };
  
      const result: SignInWithAppleResponse = await SignInWithApple.authorize(options);
      const appleUserId                     = result.response?.user;
      const email                           = result.response?.email; 
      if (email) {
        // Save email securely
        await this.saveEmail(email);
      }
      // Retrieve saved email if it's not provided (Apple only gives email on first login)
      const storedEmail = await this.getEmail();
      return { userId: appleUserId, email: storedEmail || email };
    } catch (error) 
    {
      throw error;
    }
  }

   // Save email permanently
async  saveEmail(email: string) {
  await Preferences.set({
    key: 'user_email',
    value: email,
  });
}

// Get saved email
async getEmail() {
  const { value } = await Preferences.get({ key: 'user_email' });
  return value;
}
  

  async Getplarform(){
    const info = await Device.getInfo();
    return info.platform
  }
  // Apple Sign-In
  async appleSignInWeb() {
    try {
      const provider = new OAuthProvider('apple.com');
      var result     = await this.afAuth.signInWithPopup(provider);
      return result;
    } catch (error)
    {
      throw error;
    }
  }
  // Google Sign-In
  async googleSignInWeb() {
    try 
    {
      const provider = new GoogleAuthProvider(); 
      return await this.afAuth.signInWithPopup(provider);
    } catch (error) {
      throw error;
    }
  }
  // Sign Out
  async signOut() {
    try {
      return await this.afAuth.signOut();
    } catch (error) {
      throw error;
    }
  }


  async googleloginmobile(){
    try {
      const result = await OAuth2Client.authenticate({
        appId: "818330336172-jcvtdsknjfnlk100uv8hm1s3rtf3krm7.apps.googleusercontent.com",
        authorizationBaseUrl: "https://accounts.google.com/o/oauth2/auth",
        accessTokenEndpoint: "https://www.googleapis.com/oauth2/v4/token",
        responseType: "code",
        redirectUrl: "com.touchconnectapp.app:/oauth2redirect/google",
        scope: "email profile openid",
      });
  
      if (!result?.access_token_response?.id_token) {
        throw new Error("No ID token received");
      }
      
      const decodedToken: any = jwtDecode(result.access_token_response.id_token);
      const userEmail = decodedToken?.email;
      if (!userEmail) throw new Error("Email not found in ID token");
      return userEmail;

    } catch (error) 
    {

      return "Google authentication failed" + error;
    }
  }



}
